import {Component, OnInit} from '@angular/core';
import {JsonFormsControl} from '@jsonforms/angular';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import {NgFor, NgIf} from '@angular/common';

@Component({
  selector: 'app-custom-jsonforms-material-select',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    NgFor,
    NgIf
  ],
  templateUrl: './custom-jsonforms-material-select.component.html',
  styleUrl: './custom-jsonforms-material-select.component.scss',
})
export class CustomJsonformsMaterialSelectComponent extends JsonFormsControl implements OnInit {
  oneOf: any;

  override ngOnInit() {
    super.ngOnInit();
    this.oneOf = this.scopedSchema?.oneOf;
  }
}
